const mfa = {
  en: {
    mfaSetupTitle: "2FA setup",
    mfaSetupSubtitle:
      "On your first login, you need to choose an two-factor option. You can change the method later.",
    mfaSetupMailOption: "I want to receive the code in my registered email.",
    mfaSetupQRCodeOption: "I want to generate the code through 2FA app.",
    title: "Security code",
    notification_mfa: "Verify your email to get your security code",
    insert_security_code: "Insert the security code",
    expired_token: "Token expired",
    resend_token: "Resend email",
    report_problem_token: "Report problem",
    resend_token_error: "Could not resend the token",
    mfaQRCodeTitle: "Two-factor authentication setup",
    mfaQRCodeSubtitle: "In your preferred two-factor app or service:",
    mfaQRCodeSteps: `Step 1<br>
      - In the app select Set up.<br>
      - The choose Scan QR code.<br>
      - When you are ready, click the button below.<br><br>
      Step 2<br>
      Use authenticator app to scan the QR code shown on your screen.`,
    mfaQRCodeQuestion: "Can’t scan QR code?",
    mfaQRCodeQuestionTitle:
      "Instead of scanning, you can enter the secret key manually usin following details:",
    mfaQRCodeQuestionAccount: "Account name",
    mfaQRCodeQuestionAccountText: "name{'@'}email.com",
    mfaQRCodeQuestionKey: "Secret key",
    mfaQRCodeQuestionKeyText: "NU5FKVTMFRTTIVTWOVTFGN3EJMYWOV3F",
    mfaQRCodeType: "Type",
    mfaQRCodeTypeText: "Time-based",
    mfaQRCodeEnterCode: "Enter code",
    mfaQRCodeDescription:
      "Verify your registered MFA App to get the security code",
    mfaQrCodeConfirmTitle: "Caution!",
    mfaQrCodeConfirmSubtitle:
      "Make sure the settings have been saved in your authentication application, otherwise you will not be able to log in.",
    mfaSync: {
      title: "Check your MFA App",
      message:
        "Your MFA App could be desynchronized, please verify it to assure that it is working properly"
    }
  },
  pt: {
    mfaSetupTitle: "2FA configuração",
    mfaSetupSubtitle:
      "Em seu primeiro login, você precisa escolher uma opção com dois fatores. Você pode mudar o método mais tarde.",
    mfaSetupMailOption: "Eu quero receber o código em meu e-mail cadastrado.",
    mfaSetupQRCodeOption: "Quero gerar o código através do aplicativo 2FA.",
    title: "Código de segurança",
    notification_mfa: "Verifique seu e-mail para obter seu código de segurança",
    insert_security_code: "Digite o código de segurança",
    expired_token: "Token expirou",
    resend_token: "Reenviar e-mail",
    report_problem_token: "Informar problema",
    resend_token_error: "Não foi possível reenviar o token",
    mfaQRCodeTitle: "Configuração de autenticação de dois fatores",
    mfaQRCodeSubtitle:
      "Em seu aplicativo ou serviço preferido de dois fatores:",
    mfaQRCodeSteps: `Passo 1<br>
        - No aplicativo, selecione Set up.<br>
        - Selecione Scan QR code.<br>
        - Quando você estiver pronto, clique no botão abaixo.<br><br>
        Passo 2<br>
        Use o aplicativo autenticador para escanear o código QR mostrado em sua tela`,
    mfaQRCodeQuestion: "Não pode digitalizar o código QR?",
    mfaQRCodeQuestionTitle:
      "Em vez de digitalizar, você pode digitar a chave secreta manualmente, utilizando os seguintes detalhes:",
    mfaQRCodeQuestionAccount: "Nome da conta",
    mfaQRCodeQuestionAccountText: "name{'@'}email.com",
    mfaQRCodeQuestionKey: "Chave secreta",
    mfaQRCodeQuestionKeyText: "NU5FKVTMFRTTIVTWOVTFGN3EJMYWOV3F",
    mfaQRCodeType: "Tipo",
    mfaQRCodeTypeText: "Baseado no tempo",
    mfaQRCodeEnterCode: "Digite o código",
    mfaQRCodeDescription:
      "Verifique seu aplicativo MFA registrado para obter o código de segurança",
    mfaQrCodeConfirmTitle: "Atenção!",
    mfaQrCodeConfirmSubtitle:
      "Tenha certeza de que as configurações foram salvas no seu aplicativo de autenticação, caso contrário você não poderá acessar o sistema.",
    mfaSync: {
      title: "Verifique seu aplicativo MFA",
      message:
        "Seu aplicativo MFA pode estar dessincronizado, por favor, verifique se ele está funcionando corretamente"
    }
  },
  es: {
    mfaSetupTitle: "2FA configuración",
    mfaSetupSubtitle:
      "En su primer inicio de sesión, debe elegir una opción de dos factores. Puedes cambiar el método más tarde.",
    mfaSetupMailOption:
      "Quiero recibir el código en mi correo electrónico registrado.",
    mfaSetupQRCodeOption:
      "Quiero generar el código a través de la aplicación 2FA.",
    title: "Código de seguridad",
    notification_mfa:
      "Verifique su correo electrónico para obtener su código de seguridad",
    insert_security_code: "Introduzca el código de seguridad",
    expired_token: "Ficha caducada",
    resend_token: "Reenviar correo electrónico",
    report_problem_token: "Informar de un problema",
    resend_token_error: "No se puede reenviar el token",
    mfaQRCodeTitle: "Configuración de la autenticación de dos factores",
    mfaQRCodeSubtitle: "En su aplicación o servicio de dos factores preferido:",
    mfaQRCodeSteps: `Paso 1<br>
      - En la aplicación, seleccione Configurar.<br>
      - Seleccione Escanear código QR.<br>
      - Cuando esté listo, haga clic en el botón de abajo.<br><br>
      Paso 2<br>
      Utilice la aplicación de autenticación para escanear el código QR que aparece en su pantalla`,
    mfaQRCodeQuestion: "¿No puede escanear el código QR?",
    mfaQRCodeQuestionTitle:
      "En lugar de escanear, puede introducir la clave secreta manualmente utilizando los siguientes datos:",
    mfaQRCodeQuestionAccount: "Nombre de la cuenta",
    mfaQRCodeQuestionAccountText: "name{'@'}email.com",
    mfaQRCodeQuestionKey: "Clave secreta",
    mfaQRCodeQuestionKeyText: "NU5FKVTMFRTTIVTWOVTFGN3EJMYWOV3F",
    mfaQRCodeType: "Tipo",
    mfaQRCodeTypeText: "Basado en el tiempo",
    mfaQRCodeEnterCode: "Introduzca el código",
    mfaQRCodeDescription:
      "Verifique su aplicación MFA registrada para obtener el código de seguridad",
    mfaQrCodeConfirmTitle: "Precaución.",
    mfaQrCodeConfirmSubtitle:
      "Asegúrese de que los ajustes se han guardado en su aplicación de autenticación, de lo contrario no podrá iniciar la sesión.",
    mfaSync: {
      title: "Compruebe su aplicación AMF",
      message:
        "Su aplicación MFA puede estar desincronizada, por favor compruebe que funciona correctamente."
    }
  }
}

export default mfa
